export default __webpack_public_path__ + "static/media/user.e622b46e.svg";